
import { Component, Vue } from "vue-property-decorator";
import OverviewHistory from "../components/OverviewHistory.vue";
import Leaderboard from "../components/Base/LeaderboardTable.vue";
import GamesTableHistory from "../components/Games/GamesTableHistory.vue";
import { RawLocation, Route } from "vue-router";

@Component({
  components: {
    OverviewHistory,
    Leaderboard,
    GamesTableHistory,
  },
  beforeRouteLeave(
    to: Route,
    from: Route,
    next: (to?: RawLocation | false) => void
  ): void {
    this.$store.commit("gameStore/historyGame", []);
    next();
  },
})
class History extends Vue {
  selectedValue = "";
  leaderBoardTitle = "";
  created(): void {
    this.$store.commit("authenication/setNavTab", 4);
  }

  get selectedGameValue(): string {
    return this.selectedValue;
  }

  handleGameSelection(row: any): void {
    this.selectedValue = row.key;
    this.leaderBoardTitle = row.meta.admin_name;
  }
}

export default History;
